// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrVeeAptHtPdC5 {
  display: flex;
  justify-content: center;
}
.nBXA0rsPBiQ41g {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
}
.gjuE3aSGXvF_a4 svg {
  width: 24px;
  height: 24px;
}
.xpBk2QK4wMw89M svg {
  width: 20px;
  height: 20px;
}
.aUEUEVLrSjaA4S {
  display: flex;
  justify-content: end;
  column-gap: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var qcMethodIcons = `hrVeeAptHtPdC5`;
export var qcMethodIcon = `nBXA0rsPBiQ41g`;
export var qcMethodIconEmail = `gjuE3aSGXvF_a4`;
export var qcMethodIconMobile = `xpBk2QK4wMw89M`;
export var footer = `aUEUEVLrSjaA4S`;
export default ___CSS_LOADER_EXPORT___;
